import dayjs from "dayjs";

export interface OperatingHoursCheckResult {
  isOutside: boolean;
  message?: string;
  isValidationEnabled: boolean;
}

export const checkBranchOperatingHours = (
  branch: any,
  exemptOperationsValidation?: string,
  isMalaysia?: boolean,
): OperatingHoursCheckResult => {
  const isValidationEnabled =
    String(exemptOperationsValidation || "No").toLowerCase() === "1" ||
    String(exemptOperationsValidation || "No").toLowerCase() === "no";

  const now = dayjs();
  const currentMinutes = now.hour() * 60 + now.minute();
  const dayOfWeek = now.format("dddd").toLowerCase();

  const workingHours = branch?.working_days?.[dayOfWeek];

  if (!workingHours || typeof workingHours !== "string" || !workingHours.includes(" - ")) {
    return {
      isOutside: false,
      isValidationEnabled,
    };
  }

  try {
    const [startPart, endPart] = workingHours.split(" - ");
    const [startHour, startMin] = startPart.split(":").map(Number);
    const [endHour, endMin] = endPart.split(":").map(Number);

    const startMinutes = startHour * 60 + startMin;
    const endMinutes = endHour * 60 + endMin;

    const isOutside = currentMinutes < startMinutes || currentMinutes > endMinutes;

    let msg = "";
    if (isOutside) {
      msg = `Retail transactions are blocked outside branch operating hours (${workingHours}).`;
      if (!isValidationEnabled) {
        console.warn(
          `[AUDIT WARNING] Retail transaction is being performed outside configured branch operating hours (${workingHours}) while MDM validation is disabled.`,
        );
      }
    }

    return {
      isOutside,
      message: msg,
      isValidationEnabled,
    };
  } catch (error) {
    console.error("Error parsing branch working hours:", error);
    return {
      isOutside: false,
      isValidationEnabled,
    };
  }
};
